<script lang="ts" module>
	// count of pdf viewers created
	let current_id_index = 0;

	// whether a new adobe sdk script tag should be inserted
	let adobeTagInserted = false;

	let adobeSdkReady = writable(false);
	let adobePDFSdk = new Promise<NonNullable<Window['AdobeDC']>>((resolve) => {
		if (browser) {
			if (window.AdobeDC) {
				console.debug('adobe sdk already present on window');
				resolve(window.AdobeDC);
			} else {
				document.addEventListener('adobe_dc_view_sdk.ready', function () {
					console.debug('loaded adobe sdk');
					resolve(window.AdobeDC as NonNullable<typeof window.AdobeDC>);
				});
			}
		}
	});
	if (browser) {
		if (window.AdobeDC) {
			console.debug('adobe sdk already present on window');
			adobeSdkReady.set(true);
		} else {
			document.addEventListener('adobe_dc_view_sdk.ready', function () {
				console.debug('loaded adobe sdk');
				adobeSdkReady.set(true);
			});
		}
	}
</script>

<script lang="ts">
	import { browser } from '$app/environment';
	import { PUBLIC_ADOBE_PDF_API_KEY } from '$env/static/public';
	import { onMount } from 'svelte';
	import { writable } from 'svelte/store';

	current_id_index++;
	// eslint-disable-next-line @typescript-eslint/restrict-plus-operands
	const div_to_replace_id = 'adobe-dc-view-' + current_id_index;

	const shouldInsertAdobeTag = !adobeTagInserted;
	adobeTagInserted = true;

	interface Props {
		src: string;
		fileName?: string | undefined;
	}

	let { src, fileName = undefined }: Props = $props();

	onMount(() => {
		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		adobePDFSdk.then((AdobeDC) => {
			console.log('Promise completeddddd');
			console.log(AdobeDC);

			let adobeDCView = new AdobeDC.View({
				clientId: PUBLIC_ADOBE_PDF_API_KEY,
				divId: div_to_replace_id
			});
			adobeDCView.previewFile(
				{
					content: {
						location: {
							url: src
						}
					},
					metaData: {
						// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
						fileName: fileName || src
					}
				},
				{ embedMode: 'SIZED_CONTAINER', showDownloadPDF: false, showPrintPDF: false }
			);
		});
	});
</script>

<svelte:head>
	{#if shouldInsertAdobeTag}
		<script defer src="https://acrobatservices.adobe.com/view-sdk/viewer.js"></script>
	{/if}
</svelte:head>

<div class="flex h-full w-full flex-col">
	<div class="grid h-full w-full">
		<div id={div_to_replace_id} class="col-start-1 row-start-1 h-full w-full"></div>
		{#if !$adobeSdkReady}
			<div
				class="bg-main-text/20 text-main-text/50 -z-20 col-start-1 row-start-1 grid h-full animate-pulse items-center text-center text-5xl"
			>
				<p>PDF Viewer Loading</p>
			</div>
		{/if}
	</div>
	<div class="py-1 text-sm">
		<!-- eslint-disable svelte/no-navigation-without-resolve -->
		<a href={src} class="text-link-main" target="_blank">
			<!-- eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -->
			{fileName || src} (Open PDF in new tab )
		</a>
	</div>
</div>
